import { equals } from "VSS/Utils/String";
import { DevelopmentZeroDataSettingsResponse } from "TFS/WorkItemTracking/DataProviderContracts";
import { WebPageDataService } from "VSS/Contributions/Services";
import { getService } from "VSS/Service";
import { publishEvent, TelemetryEventData } from "VSS/Telemetry/Services";

const promoteGitHubLinkificationDataProviderId = "ms.vss-work-web.development-zerodata-settings-data-provider";
export class DevelopmentZeroDataSettingsService {
    private _projectId: string;
    private _developmentZeroDataSettingsResponse: DevelopmentZeroDataSettingsResponse;

    public async getDevelopmentZeroDataExperienceSettings(projectId: string): Promise<DevelopmentZeroDataSettingsResponse> {
        if (!this._projectId || !equals(this._projectId, projectId, true)) {
            this._projectId = projectId;
            const parameters = {
                projectId
            };
            const pageDataService = getService(WebPageDataService);
            try {
                this._developmentZeroDataSettingsResponse = await pageDataService.getDataAsync<DevelopmentZeroDataSettingsResponse>(
                    promoteGitHubLinkificationDataProviderId,
                    null,
                    parameters
                );
            } catch (error) {
                publishEvent(new TelemetryEventData("ZeroDataSettingsError", "getDevelopmentZeroDataExperienceSettings", { error }));
            }
        }

        return this._developmentZeroDataSettingsResponse;
    }
}
